import * as angular from "angular";

export class PrintService {
    printSection: HTMLElement;

    static $inject = ["$window", "$document"];

    constructor(private readonly $window: angular.IWindowService, private readonly $document: angular.IDocumentService) {
        this.printSection = document.getElementById("printSection");

        // if there is no printing section, create one
        if (!this.printSection) {
            this.printSection = document.createElement("div");
            this.printSection.id = "printSection";

            document.body.appendChild(this.printSection);
        }

        if (window.matchMedia) {
            const mediaQueryList = this.$window.matchMedia("print");

            mediaQueryList.addListener((mql) => {

                if (!mql.matches) {
                    this.afterPrint();
                }
            });
        }

        this.$window.onafterprint = this.afterPrint;
    }

    print(elementName: string) {
        const elemToPrint = angular.element(elementName) as any;

        this.printElement(elemToPrint[0]);
    }

    printCanvas(canvas: any, landscape: boolean) {
        const canvasImage = canvas.toDataURL("image/png");

        const styles = landscape ? "@page{size:landscape;}" : "";

        const html = `<style>${styles}</style><img id='Image' src=${canvasImage} style='width:100%;'></img>`;

        //this.printSection.innerHTML = html;
        //this.$window.print();

        var printWindow = this.$window.open("");

        $(printWindow.document.body)
            .html(html)
            .ready(() => {
                printWindow.focus();
                printWindow.print();
                printWindow.close();
            });
    }

    private printElement(elem: HTMLElement) {
        // clones the element you want to print
        const domClone = elem.cloneNode(true);

        this.printSection.innerHTML = "";
        this.printSection.appendChild(domClone);

        this.$window.print();
    }

    private afterPrint() {
        this.printSection.innerHTML = "";
    }
}
